/**
 * Which plated dish component this ingredient ends up on. Recipe inputs
 * (oil, cumin, lemon juice) list every component whose recipe uses them;
 * main components list the dishes they are plated on.
 */
export function usedOnRows(ingredient) {
  if (ingredient.used_on?.length) {
    return ingredient.used_on.map((use) => ({
      key: `${use.dish_id}:${use.component}:${use.recipe_id}`,
      dish: use.dish_name,
      component: use.component,
      via: use.recipe_name && use.recipe_name !== use.component ? use.recipe_name : null,
      lbs: use.quantity_lbs,
    }))
  }
  return (ingredient.dishes || []).filter((dish) => dish.dish_name).map((dish) => ({
    key: `${dish.dish_id}:${dish.component || ''}`,
    dish: dish.dish_name,
    component: dish.component || ingredient.display_name || ingredient.ingredient_name,
    via: null,
    lbs: dish.needed_lbs,
  }))
}
